<template>
<div class="panelNagusia">
  <div class="ui breadcrumb">
    <a class="section" v-on:click="goTo('/dashboard')">Home</a>
    <i v-if="id" class="right angle icon divider"></i>
    <a v-if="id" class="active" v-on:click="goTo('/corporations')">Corporaciones</a>
    <i class="right angle icon divider"></i>
    <a class="section" v-on:click="goTo('/corporations/users')">Usuarios</a>
    <i class="right angle icon divider"></i>
    <a class="active section">Añadir Usuario</a>
  </div>
  <h1 class="ui header"><i class="icon user"></i>
    <div class="content">Añadir Usuario</div>
  </h1>
  <button v-if="id" class="ui basic button rightButton" v-on:click="goTo('/corporations/'+id+'/users')">
    <i class="long arrow alternate left icon"></i>Atras
  </button>
  <button v-if="!id" class="ui basic button rightButton" v-on:click="goTo('/corporations/users')">
    <i class="long arrow alternate left icon"></i>Atras
  </button>
  <div class="ui stackable two column divided grid container">
    <div class="row">
      <div class="column">
        <form class="ui form" @submit.prevent="newCorporateUser">
          <h4 class="ui dividing header">Información del usuario</h4>
          <div class="inline field">
            <sui-checkbox label="Activo" toggle v-model="newUserData.active" />
          </div>
          <div class="field">
            <label>Nombre</label>
            <input type="text" v-model="newUserData.name" placeholder="Nombre" required>
          </div>
          <div class="field">
            <label>Apellidos</label>
            <input type="text" v-model="newUserData.surname" placeholder="Apellidos" required>
          </div>
          <div class="field">
            <label>Teléfono</label>
            <input type="text" v-model="newUserData.phone_number" placeholder="Teléfono">
          </div>
          <div class="field">
            <label>Email</label>
            <input type="text" v-model="newUserData.email" placeholder="Email">
          </div>
          <button id="save" class="ui button" type="submit">Crear</button>
        </form>
      </div>
    </div>
  </div>
</div>
</template>
<script>
import { hapiickApi } from '@/api/hapiickApi';
export default {
  name: 'addCorporationsUser',
  props: ['id'],
  data() {
    return {
      newUserData: {
        coporation_id:this.id,
        name: null,
        surname: null,
        phone_number: null,
        email: null,
        active: 1
      },
    }
  },
  created() {
    let role = JSON.parse(localStorage.admin).role
    if (role === 'master' || role === 'admin' || role==='corporate' || role==='hmyCorporate') {

    } else {
      this.$router.replace('/parcels_v2')
    }
  },
  methods: {
    newCorporateUser() {
      let x = document.getElementById("save");
      x.classList.add("loading");
      x.disabled = true;
      hapiickApi().post('/v2/corporations/users/add', {
        admin_id: JSON.parse(localStorage.admin).id,
        userData: this.newUserData
      })
      .then(request => {
        this.userSaved(request)
      })
    },
    goTo(where) {
      this.$router.push(where)
    },
    userSaved(req) {
      let msg = '';
      if (req.data.status !== "OK") {
        if (req.data.status === "KO") {
          msg = req.data.message;
        } else {
          msg = 'No se han podido guardar los datos';
        }
        this.$swal({
          type: 'error',
          title: 'Error',
          text: msg
        })
        let x = document.getElementById("save");
        x.classList.remove("loading");
        x.disabled = false;
      } else {
        this.$swal({
          type: 'success',
          title: 'Los datos se han guardado correctamente',
          showConfirmButton: false,
          timer: 2500
        })
        this.newUserData = null
        if (this.id) {
          this.goTo('/corporations/'+this.id+'/users')
        } else {
          this.goTo('/corporations/users')
        }
      }

    }
  }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Corporations/addCorporationsUser.vue